import '../styles/PageGlobal.css';
import './ReceptionPage.css';
import React from "react";
import { useParams } from "react-router-dom";


export default function ReceptionPage() {
  const { reception_id } = useParams();

  return (
    <div  className="containerMain">
  <h1>Récéption</h1>
  <p>Ceci est un contenu protégé</p>
<p style={{ color: "red" }}>
        DEBUG reception_id: {reception_id}
      </p>
  
</div>
  );
}